import { render, staticRenderFns } from "./SecrectPage.vue?vue&type=template&id=456f9224&scoped=true"
import script from "./SecrectPage.vue?vue&type=script&lang=js"
export * from "./SecrectPage.vue?vue&type=script&lang=js"
import style0 from "./SecrectPage.vue?vue&type=style&index=0&id=456f9224&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f9224",
  null
  
)

export default component.exports